import React from 'react'
import { withRouter } from 'react-router-dom'
import { Component } from 'reflux'
import PowerBIReportEmbed from '../../components/PowerBIReportEmbed'

class PowerBIDashboardFrame extends Component {
  constructor(props) {
    super(props)
    this.state = { isWelcomeDashboard: false }
  }

  getIds() {
    const { WorkspaceID, ReportID, match } = this.props
    return {
      WorkspaceID: WorkspaceID || match?.params?.WorkspaceID,
      ReportID: ReportID || match?.params?.ReportID
    }
  }

  componentDidMount() {
    const { WorkspaceID, ReportID } = this.getIds()
    this.embedReport(WorkspaceID, ReportID)
  }

  componentDidUpdate(prevProps) {
    const prev = {
      WorkspaceID: prevProps.WorkspaceID || prevProps.match?.params?.WorkspaceID,
      ReportID: prevProps.ReportID || prevProps.match?.params?.ReportID
    }
    const curr = this.getIds()
    if (curr.WorkspaceID !== prev.WorkspaceID || curr.ReportID !== prev.ReportID) {
      this.embedReport(curr.WorkspaceID, curr.ReportID)
    }
  }

  embedReport = (workspaceId, reportId) => {
    this.setState({ isWelcomeDashboard: true })
    if (!workspaceId || !reportId) return
  }

  render() {
    const { WorkspaceID, ReportID } = this.getIds()
    if (!WorkspaceID || !ReportID) return <h3>Could not load dashboard</h3>

    return (
      <React.Fragment>
        <PowerBIReportEmbed key={`${WorkspaceID}:${ReportID}`} reportId={ReportID} workspaceId={WorkspaceID} />
      </React.Fragment>
    )
  }
}

export default withRouter(PowerBIDashboardFrame)
